<div class="content-card-Trainings list-trainings">
    <div class="sub-header-trainings">
      <!--PHOTO -->
      <div class="content-img-trainings">
        <div class="button-container-trainings">
          <img class="img-perfil-trainings" [src]="getImg()"  alt="">
          <a (click)="onClickUpdatePhoto()"
             [class.disabled]="disableFieldsInEditMode"
             [style.pointer-events]="disableFieldsInEditMode ? 'none' : 'auto'">
            <mat-icon>camera_alt</mat-icon>
          </a>
        </div>
      </div>

      <div class="sub-content-trainings">
        <form [formGroup]="formTrainingType" style="width: 100%;">
          <mat-form-field class="input-field-trainings" appearance="outline">
            <label><strong>Nombre de la capacitación</strong></label>
            <input matInput #nameInput type="text" formControlName="Name" maxlength="{{250}}" [disabled]="disableFieldsInEditMode">
            <mat-error>Requerido</mat-error>
          </mat-form-field>
          <mat-form-field class="input-field-trainings" appearance="outline">
            <label><strong>Descripciòn</strong></label>
            <input matInput #descriptionInput type="text" formControlName="Description" maxlength="{{350}}" [disabled]="disableFieldsInEditMode" >
            <mat-error>Requerido</mat-error>
          </mat-form-field>
          <div class="order-container">
            <div class="order-input-container">
              <label><strong >Orden</strong></label>
              <mat-form-field appearance="outline" class="order-field" style="margin-top: -7px" >
                <input matInput type="text" formControlName="Order" maxlength="350" [disabled]="disableFieldsInEditMode">
                <mat-error>Requerido</mat-error>
              </mat-form-field>
            </div>

            <div class="state-container">
              <label><strong>Estado</strong></label>
              <mat-form-field appearance="outline" class="state-field" style="margin-top: -7px;">
                <mat-select formControlName="State" placeholder="Seleccione estado">
                  <mat-option [value]="0" [disabled]="editData && isDesignDisabled">Diseño</mat-option>
                  <mat-option [value]="1">Inactivo</mat-option>
                  <mat-option [value]="2">Activo</mat-option>
                </mat-select>
                <mat-error>Requerido</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="actions-dialog-trainings" style="margin: 3px;">
            <button mat-button class="btn-cancelar" (click)="cancelTrainings()" type="button">CANCELAR</button>&nbsp;&nbsp;
            <button mat-button type="submit" class="btn-generar" (click)="onSubmitTypeTrainings()" [disabled]="disableFieldsInEditMode && !isStateChanged">GUARDAR</button>
          </div>
        </form>
      </div>
    </div>
</div>

